import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=58c18e3b&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=58c18e3b&prod&lang=scss"
import style1 from "./Permissions.vue?vue&type=style&index=1&id=58c18e3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c18e3b",
  null
  
)

export default component.exports